import _objectWithoutProperties from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];
import React from 'react';
import parse from 'html-react-parser';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
function TooltipECS(_ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var classN = restProps.className || '';
  var toShowCloseBtn = typeof restProps.closeButton !== 'undefined' ? restProps.closeButton : true;
  var trigger = restProps.trigger || ['click', 'hover'];
  var rootClose = typeof restProps.rootClose !== 'undefined' ? restProps.rootClose : true;
  var placement = restProps.placement || 'auto';
  return React.createElement(OverlayTrigger, {
    trigger: trigger,
    rootClose: rootClose,
    placement: placement,
    overlay: React.createElement(Tooltip, {
      id: restProps.id,
      className: classN
    }, toShowCloseBtn && React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return document.body.click();
      },
      className: "btn pe-0 pt-0 ecs-font-icon-act-close text-white float-end",
      "aria-label": "Close the tooltip"
    }), parse(restProps.body))
  }, children);
}
export default TooltipECS;